import styled, { css, keyframes } from 'styled-components';
import { TextField } from '@material-ui/core';

interface TabButtonProps {
  ativa: boolean;
}

const fadeIn = keyframes`
  from {
      opacity: 0;
      transform: translateY(-20px);
  }
  to {
      opacity: 1;
      transform: translateY(0);
  }
`;

const ButtonStyle = css`
  cursor: pointer;
  animation: ${fadeIn} 1s;
  width: 100%;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 8px;

  background: ${props => props.theme.secundaria};
  border-radius: 8px;
  border: none;
  flex: 1;
  /* width: 100%; */

  height: 30px;
  color: #fff;

  transition: color 0.3s;
  transition: background-color 0.1s;

  &:hover {
    background-color: ${props => props.theme.secundariaShade};
  }

  &:active {
    background-color: ${props => props.theme.primaria};
  }

  svg {
    height: 20px;
    width: 20px;
    margin-right: 8px;
  }
`;

const detectBrowser = () => {
  const userAgent = navigator.userAgent;

  if (userAgent.includes('Chrome')) {
    return 'chrome';
  } else if (userAgent.includes('Firefox')) {
    return 'firefox';
  } else if (userAgent.includes('Safari')) {
    return 'safari';
  } else {
    return 'other'; // Para outros navegadores
  }
};

const getScrollbarStyles = (browser: string) => {
  if (browser !== 'firefox') {
    return css`
      /* Estilizando o Scrollbar para Chrome/Safari */
      &::-webkit-scrollbar {
        width: 5px;
        height: 5px; /* Para barras de rolagem horizontais */
      }

      &::-webkit-scrollbar-thumb {
        cursor: pointer;
        background-color: ${props =>
          props.theme.secundaria}; /* Cor do "thumb" */
        border-radius: 10px;
        border: 3px solid transparent;
      }

      &::-webkit-scrollbar-track {
        background-color: #f0f0f0; /* Cor do "track" */
        margin-bottom: 5px;
      }

      /* Remove as setas do scrollbar em WebKit */
      &::-webkit-scrollbar-button {
        display: none; /* Remove as setas do scrollbar */
      }
    `;
  } else {
    return css`
      /* Estilizando o Scrollbar para Firefox */
      scrollbar-width: thin; /* Largura do scrollbar: "auto" ou "thin" */
      scrollbar-color: ${props => props.theme.secundaria} #f0f0f0; /* Cor do thumb e do track */
    `;
  }
};

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  animation: ${fadeIn} 2s;
  overflow: hidden;

  .MuiTextField-root {
    /* contorno do input */
    & .MuiOutlinedInput-root {
      fieldset {
        &.MuiOutlinedInput-notchedOutline {
          border-color: ${props => props.theme.secundaria} !important;
        }
      }
    }
    /* Contorno do input no hover */
    &:hover {
      & .MuiOutlinedInput-root {
        fieldset {
          &.MuiOutlinedInput-notchedOutline {
            border-color: ${props => props.theme.secundariaShade} !important;
          }
        }
      }
    }
    /* contorno quando foca no input */
    & .MuiOutlinedInput-root {
      &.Mui-focused fieldset {
        border-color: ${props => props.theme.secundariaShade} !important;
      }
    }
    /* cor da fonte do input */
    & .MuiOutlinedInput-input {
      color: ${props => props.theme.texto} !important;
      /* letra maiúscula no input */
      text-transform: uppercase;
    }
    /* label quando preenchido */
    & label.MuiFormLabel-filled {
      color: ${props => props.theme.secundaria} !important;
    }
    /* label em cima do input */
    & label.Mui-focused {
      color: ${props => props.theme.secundariaShade} !important;
    }
    /* seria o placeholder */
    > label {
      color: ${props => props.theme.textoClaro};
    }
  }
`;

export const CustomCheckBox = styled.label`
  cursor: pointer;

  display: flex;
  align-items: center;

  @media (min-width: 768px) {
    margin-left: 8px;
    align-self: center;
  }

  input {
    cursor: pointer;

    appearance: none;
    width: 16px;
    height: 16px;
    border: 2px solid ${props => props.theme.secundaria};
    border-radius: 4px;
    background-color: white;
    transition:
      background-color 0.3s,
      border-color 0.3s;

    margin-right: 5px;

    :checked {
      background-color: ${props => props.theme.secundaria};
      border-color: ${props => props.theme.secundaria};
    }

    :checked::after {
      content: '✔';
      color: white;
      font-size: 12px;
      text-align: center;
      display: block;
      position: relative;
      top: -2px;
    }
  }
`;

export const GroupBoxUsuario = styled.fieldset`
  display: flex;
  flex-direction: column;
  border: 1px solid ${props => props.theme.secundaria} !important;
  border-radius: 10px;
  padding: 0 10px 10px !important;

  height: 100%;

  overflow: auto;

  margin-bottom: 8px;

  ${getScrollbarStyles(detectBrowser())};

  span {
    animation: ${fadeIn} 1s;

    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;

    width: 100%;

    @media (max-width: 768px) {
      flex-direction: column;
    }
  }
`;

export const GroupBoxLegenda = styled.legend`
  font-size: 20px !important;
  /* font-weight: bold !important; */
  text-align: left !important;
  color: ${props => props.theme.secundaria};
  width: auto;
  padding: 0px 5px;
  border-bottom: none;
`;

export const InputNome = styled(TextField)`
  flex: 1;
  width: 100%;
  @media (min-width: 768px) {
    margin-right: 8px !important;
  }
`;

export const InputValorHora = styled(TextField)`
  flex: 1;
  width: 100%;

  & input {
    text-align: right;
  }

  & input[type='number'] {
    -moz-appearance: textfield; /* Firefox */
  }

  & input[type='number']::-webkit-outer-spin-button,
  & input[type='number']::-webkit-inner-spin-button {
    -webkit-appearance: none; /* Chrome, Safari, Edge */
    margin: 0;
  }
`;

export const InputEmail = styled(TextField)`
  flex: 1;
  width: 100%;
  @media (min-width: 768px) {
    margin-right: 8px !important;
  }
`;

export const InputSenha = styled(TextField)`
  flex: 1;
  @media (min-width: 768px) {
    margin-right: 8px !important;
  }
`;

export const BotoesContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;

  margin-top: auto;
`;

export const BotaoSalvar = styled.div`
  ${ButtonStyle}
`;

export const BotaoLimpar = styled.div`
  ${ButtonStyle}
`;

export const InputNomePesquisa = styled(TextField)`
  flex: 1;
  width: 100%;
  @media (min-width: 768px) {
    margin-right: 8px !important;
  }
`;

export const InputEmailPesquisa = styled(TextField)`
  flex: 1;
  width: 100%;
  @media (min-width: 768px) {
    margin-right: 8px !important;
  }
`;

export const ContainerPesquisa = styled.div`
  animation: ${fadeIn} 1s;

  display: flex;
  flex-direction: column;

  overflow-y: auto;
  overflow-x: hidden;

  ${getScrollbarStyles(detectBrowser())};
`;

export const CardPesquisa = styled.div`
  animation: ${fadeIn} 1s;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  //min-height: 65px;
  margin: 0px 5px 5px 0px;
  width: 100%;
  max-width: 100%;

  cursor: pointer;
  padding: 10px;

  border: 1px solid ${props => props.theme.secundaria};
  border-radius: 8px;

  background-color: #ffffff;
  border-radius: 8px;

  p:first-child {
    color: ${props => props.theme.secundaria};
    font-weight: bold;
  }

  div {
    display: flex;
    flex-direction: column;
    gap: 10px;
    word-break: break-word;
  }

  svg {
    cursor: pointer;

    margin-left: 5px;

    height: 22px;
    width: 22px;

    color: ${props => props.theme.secundaria};

    &:hover {
      color: ${props => props.theme.secundariaShade};
    }
  }
`;

export const Botao = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;

  align-self: flex-start;
  height: 56px;
  width: 56px;

  margin-top: 15px;

  border: none;
  border-radius: 8px;
  background-color: ${props => props.theme.secundaria};

  svg {
    height: 25px;
    width: 25px;
    color: #ffffff;
  }

  &:hover {
    background-color: ${props => props.theme.secundariaShade};
  }

  @media (max-width: 768px) {
    margin-left: 8px;
    margin-bottom: 8px;

    svg {
      height: 20px;
      width: 20px;
    }
  }
`;

export const ContainerButton = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  flex: 1;
  width: 100%;

  @media (max-width: 768px) {
    gap: 0;
  }
`;

export const ContainerTabs = styled.div`
  display: flex;
  flex-direction: row;
  align-self: flex-end;

  padding: 5px;
  gap: 5px;
`;

export const TabButton = styled.button<TabButtonProps>`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 40px;
  height: 40px;
  padding: 8px;

  border: 2px solid
    ${props => (props.ativa ? 'transparent' : props.theme.secundaria)};
  border-radius: 8px;
  background-color: ${props =>
    props.ativa ? props.theme.secundaria : 'white'};
  color: ${props => (props.ativa ? 'white' : props.theme.secundaria)};
  font-size: 14px;
  cursor: pointer;

  svg {
    height: 30px;
    width: 30px;
  }

  &:hover {
    color: #ffffff;
    background-color: ${props => props.theme.secundaria};
  }
`;

export const ContainerHorario = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;

  @media (max-width: 768px) {
    width: 330px;
  }

  height: 100%;
  overflow-x: auto;

  h3 {
    color: white;
    background-color: ${props => props.theme.secundaria};

    padding: 3px;
    text-align: center;

    border-radius: 8px;
    margin-right: 10px;

    margin-bottom: 10px;
  }

  ${getScrollbarStyles(detectBrowser())};
`;

export const CardHorario = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  min-width: 170px;

  padding: 10px;

  margin-right: 10px;
  margin-bottom: 10px;
  border-radius: 10px;
  border: 1px solid ${props => props.theme.secundaria};

  h4 {
    font-size: 18px;
    color: ${props => props.theme.secundaria};
  }

  div {
    display: flex;

    gap: 10px;

    p {
      font-size: 16px;

      span {
        font-weight: bold;
        color: ${props => props.theme.secundaria};
      }
    }

    svg {
      cursor: pointer;

      height: 20px;
      width: 20px;

      color: ${props => props.theme.secundaria};

      margin-top: 10px;
      margin-left: 10px;
    }
  }
`;

export const BotaoHorario = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;

  align-self: flex-start;
  height: 56px;
  width: 56px;

  margin-top: 15px;

  border: none;
  border-radius: 8px;
  background-color: ${props => props.theme.secundaria};

  svg {
    height: 25px;
    width: 25px;
    color: #ffffff;
  }

  &:hover {
    background-color: ${props => props.theme.secundariaShade};
  }

  @media (max-width: 768px) {
    margin: 8px 0px;

    width: 100%;
    height: auto;

    padding: 5px;

    svg {
      height: 20px;
      width: 20px;
    }
  }
`;
